import React from "react";

const Footer = () => {
  return (
    <div className=" py-32 text-gray-400 bg-gray-800">
      <h1 className=" text-3xl mb-2">
        touch<span className=" text-5xl mb-2 text-teal-400">IT</span>
      </h1>
      <h1 className=" text-lg mb-5">Make Your Home Smart</h1>
      <div>All rights reserved by 2022 &copy; touchIT copyright law.</div>
    </div>
  );
};

export default Footer;
